import { render, staticRenderFns } from "./scoreReportDialog.vue?vue&type=template&id=bf3c0210"
import script from "./scoreReportDialog.vue?vue&type=script&lang=js"
export * from "./scoreReportDialog.vue?vue&type=script&lang=js"
import style0 from "./scoreReportDialog.vue?vue&type=style&index=0&id=bf3c0210&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports